<template>
  <section id="whats" class="section--pt-xlg">
    <div class="inner">
      <h2 class="Head Head--cl01 Head--mg_md">
        <span class="Head__main Head--md">WHAT'S MINDFULNESS CLASS</span><br><span class="Head__main_jp">マインドフルネスの理論を学ぶ</span>
      </h2>
      <p class="_l-lg _mg-b20">
        マインドフルネスは、継続した実践が大切ですが、理論を学ぶことで効果を感じやすくなります。<br>理論と実践を学ぶ「What's Mindfulness」クラスは、毎月4回のクラスを1シリーズとして開催していますので、ぜひ月初のクラスからご参加ください。<br>※ 動画はこちらに掲載します。
      </p>
      <div class="Movie__area _mg-b20">
        <div class="Movie__inner">
          <iframe src="https://player.vimeo.com/video/756642345?h=945895e377" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="20210908 What&amp;#039;s Mindfulness 30 Part.1 by Sou" />
        </div>
      </div>
      <p class="_l-lg _mg-b20 _ft-cnt">
        What's Mindfulness vol.1
      </p>
      <div class="Movie__area _mg-b20">
        <div class="Movie__inner">
          <iframe src="https://player.vimeo.com/video/758941204?h=8b69883201" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="20210915 What&amp;#039;s Mindfulness 30 Part.2 by Sou" />
        </div>
      </div>
      <p class="_l-lg _mg-b20 _ft-cnt">
        What's Mindfulness vol.2
      </p>
      <div class="Movie__area _mg-b20">
        <div class="Movie__inner">
          <iframe src="https://player.vimeo.com/video/761291261?h=40797a1fc8" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="20210922 What&amp;#039;s Mindfulness 30 Part.3 by Sou" />
        </div>
      </div>
      <p class="_l-lg _mg-b20 _ft-cnt">
        What's Mindfulness vol.3
      </p>
      <div class="Movie__area _mg-b20">
        <div class="Movie__inner">
          <iframe src="https://player.vimeo.com/video/763646528?h=286da8bb16" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="20210929 What&amp;#039;s Mindfulness 30 Part.4 by Sou" />
        </div>
      </div>
      <p class="_l-lg _mg-b20 _ft-cnt">
        What's Mindfulness vol.4
      </p>
    </div>
  </section>
</template>
<script>
export default {
  name: 'MindfulnessClass'
}
</script>
